import { IRootState } from '../../../store'

export const getDefaultTempTypeSelector = (state: IRootState): string | null =>
  state.configurations.serviceConfig.DEFAULT_TEMP_MEASUREMENT
